/**
 * Soft duplicate guard for the anonymous survey: remembers, in this browser only,
 * which rounds were answered. Deliberately weak: anything stronger needs an
 * identifier, which would break anonymity.
 */
const key = (roundId) => `survey-submitted:${roundId}`;

export const hasSubmitted = (roundId) => {
  try {
    return localStorage.getItem(key(roundId)) === '1';
  } catch {
    return false;
  }
};

export const markSubmitted = (roundId) => {
  try {
    localStorage.setItem(key(roundId), '1');
  } catch {
    // Storage blocked (private window, policy): the guard is best effort.
  }
};
